import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { RouterProvider as ReactRouterProvider } from 'react-router-dom';

import createRouter from '@/core/router';

export default function RouterProvider() {
  const queryClient = useQueryClient();
  const [router] = useState(() => createRouter(queryClient));

  return <ReactRouterProvider router={router} />;
}
